import { Trans, useTranslation } from 'react-i18next';
import MicrophoneOffIcon from '@/assets/icons/microphone-off.svg?react';
import { Button, Heading, Modal, Text } from '@/components/base';

interface ErrorModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  buttonText?: string;
  onButtonClick: () => void;
  /**
   * Error type to determine which translation keys to use
   */
  errorType?: 'permission' | 'no-device';
  // Raises the modal above a full-screen dialog that opened it.
  dialogClassname?: string;
}

const RecordingErrorModal = ({
  open,
  onClose,
  title,
  description,
  buttonText,
  onButtonClick,
  errorType = 'permission',
  dialogClassname,
}: ErrorModalProps) => {
  const { t } = useTranslation('activitySession');

  const defaultTitle =
    errorType === 'no-device' ? t('error.recording_no_device_title') : t('error.recording_permission_title');

  return (
    <Modal open={open} onClose={onClose} closeButton size="sm" dialogClassname={dialogClassname}>
      <div className="flex flex-col items-center justify-center">
        <div className="my-3 flex aspect-square w-[72px] items-center justify-center rounded-full bg-revamp-apple-100">
          <MicrophoneOffIcon className="h-[38px] w-[38px] text-revamp-apple-500" />
        </div>
        <Heading variant="h5" className="my-2">
          {title ?? defaultTitle}
        </Heading>
        <Text variant="xs" className="mb-4 px-4 text-center text-gray-500">
          {description ??
            (errorType === 'no-device' ? (
              <Trans t={t} i18nKey="error.recording_no_device_description" components={{ strong: <strong /> }} />
            ) : (
              <Trans t={t} i18nKey="error.recording_permission_description" components={{ strong: <strong /> }} />
            ))}
        </Text>
        <div className="mb-2 mt-3 flex w-full gap-6">
          <Button version="revamp-v1" variant="solid" color="primary" onClick={onButtonClick} className="w-full py-3">
            {buttonText ?? t('error.recording_permission_button_text')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RecordingErrorModal;
